var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TitledCard',{attrs:{"title":_vm.$t('advanceCard')},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.openAdvanceDialog}},[_vm._v(_vm._s(_vm.$t('newAdvanceButton')))])]},proxy:true}])},[_c('AdvanceDialog',{ref:"advanceDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }